import { Text } from '@components/primitives';
import { AntDesign } from '@expo/vector-icons';
import colors from '@theme/colors';
import React from 'react';
import { View, TouchableOpacity, StyleProp, ViewStyle } from 'react-native';
import styles from './styles';

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
  style?: StyleProp<ViewStyle>;
  testID?: string;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ title, onClose, style, testID }) => (
  <View style={[styles.container, style]} testID={testID}>
    <Text variant="lg-bold" style={styles.title}>
      {title}
    </Text>
    <TouchableOpacity onPress={onClose} style={styles.closeButton} testID="modal-close-button">
      <AntDesign name="close" size={20} color={colors.neutral.charcoal} />
    </TouchableOpacity>
  </View>
);

export default ModalHeader;
